import { useNavigate } from "react-router-dom";
import { Activity, Pencil, NotebookPen, Scale, Target, Trophy, SlidersHorizontal } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const BTN = "h-11 px-4 rounded-full text-sm font-semibold inline-flex items-center gap-2 chip";

function Item({ icon: Icon, title, sub, onSelect, testid }) {
  return (
    <DropdownMenuItem onSelect={onSelect} data-testid={testid} className="min-h-11 items-start gap-3 py-2.5 cursor-pointer">
      <Icon className="h-4 w-4 mt-0.5 shrink-0 text-stone-600" />
      <span><span className="block text-sm font-medium text-stone-900">{title}</span><span className="block text-xs text-stone-500">{sub}</span></span>
    </DropdownMenuItem>
  );
}

export function ProgressActions({ hasGoals, weightActive, hasMission, onEditGoals }) {
  const nav = useNavigate();
  const toMission = () => setTimeout(() => document.querySelector('[data-testid="mission-card"]')?.scrollIntoView({ behavior: "smooth", block: "center" }), 80);
  return (
    <div className="flex flex-wrap gap-2" data-testid="today-progress-actions">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button data-testid="today-update-progress" className={`${BTN} btn-ink`}><Activity className="h-4 w-4" />Update progress</button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-72" data-testid="progress-menu">
          <DropdownMenuLabel className="text-xs font-normal text-stone-500">Goal progress counts itself when you tick a goal's must-do.</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <Item icon={NotebookPen} title="Today's check-in details" sub="Mood, stress, energy, sleep, movement, water, symptoms, cycle, a note" onSelect={() => nav("/today/log")} testid="progress-menu-checkin" />
          {hasMission && <Item icon={Target} title="This week's mission" sub="Mark today done on the mission card" onSelect={toMission} testid="progress-menu-mission" />}
          {weightActive && <Item icon={Scale} title="Log a weigh-in" sub="Weight Reset trend and weekly review" onSelect={() => nav("/journey/plan/weight")} testid="progress-menu-weight" />}
          <Item icon={SlidersHorizontal} title="Re-rate your life areas" sub="Then vs now, out of 10" onSelect={() => nav("/journey/progress")} testid="progress-menu-rerate" />
          <Item icon={Trophy} title="Add a win" sub="Evidence of change, big or small" onSelect={() => nav("/journey/story")} testid="progress-menu-win" />
        </DropdownMenuContent>
      </DropdownMenu>
      <button onClick={onEditGoals} data-testid="today-edit-goals" className={`${BTN} border border-stone-300 bg-white text-stone-900 hover:bg-stone-50`}><Pencil className="h-4 w-4" />{hasGoals ? "Edit goals" : "Set goals"}</button>
    </div>
  );
}
